import React from 'react'
import { Button, Typography } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface InfoGroupProps {
  info: {
    label: string
    value: string
  }[]
  actionText: string
  actionClick: () => void
}

export const InfoGroup = ({ info, actionText, actionClick }: InfoGroupProps): JSX.Element => {
  return (
    <S.Container>
      <S.InfoContainer>
        {info.map((info, index) => (
          <S.InfoTitleWrapper key={index}>
            <Typography variant='content2'>
              {info.label}
            </Typography>
            <Typography variant='content2'>
              {info.value}
            </Typography>
          </S.InfoTitleWrapper>
        ))}
      </S.InfoContainer>
      <S.ButtonContainer>
        <Button variant='contained' onClick={actionClick}>
          {actionText}
        </Button>
      </S.ButtonContainer>
    </S.Container>
  )
}